import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

import {UiIconModule} from '../icon/icon.module';

import {UiFieldComponent} from './field.component';
import {UiFieldPasswordComponent} from './field-password.component';
import {FieldRegexpDirective} from './field-regexp.directive';
import {FieldCapitalizeFirstDirective} from './field-capitalize-first';
import {FieldTrimDirective} from './field-trim.directive';

@NgModule({
  declarations: [
    UiFieldComponent,
    UiFieldPasswordComponent,
    FieldRegexpDirective,
    FieldCapitalizeFirstDirective,
    FieldTrimDirective
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    UiIconModule
  ],
  exports: [
    UiFieldComponent,
    UiFieldPasswordComponent,
    FieldRegexpDirective,
    FieldCapitalizeFirstDirective,
    FieldTrimDirective
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UiFieldModule {
}
